import type { PaperProps } from "@mantine/core"
import startCase from "lodash/startCase"
import type { PropsWithChildren } from "react"
import { useTranslation } from "react-i18next"
import { Pills } from "@/components/layouts"
import { useAuth, useQueryState } from "@/hooks"
import { icons } from "../utils"

type TValue = "company" | "teams" | "user"

export function RoleTabs({ children, defaultValue = "company" }: PropsWithChildren<{ defaultValue?: TValue }>) {
  const [tab = defaultValue, setTab] = useQueryState<string>("tab", { keep: ["tab", "type"] })

  return (
    <Pills value={tab} onChange={setTab} data-testid="roles-tab">
      {children}
    </Pills>
  )
}

RoleTabs.Tabs = function Tabs({ children, ...props }: PropsWithChildren<PaperProps>) {
  const { t } = useTranslation()
  const { user } = useAuth()

  return (
    <Pills.Tabs mx="auto" {...props}>
      <Pills.Tab value="company" leftSection={<icons.Company />} title={t("Company")} />

      <Pills.Tab value="teams" leftSection={<icons.Team />} title={t("Departments")} />

      <Pills.Tab
        value="user"
        leftSection={<icons.User />}
        title={startCase(user?.full_name || user?.name) || t("Personal")}
      />

      {children}
    </Pills.Tabs>
  )
}

RoleTabs.Panel = function Panel({ value, children }: PropsWithChildren<{ value: string }>) {
  return <Pills.Panel value={value}>{children}</Pills.Panel>
}
